import {NumberInput, Select, Stack, TextInput} from '@mantine/core'
import type {UseFormReturnType} from '@mantine/form'

export type OrganizationSettingsFormValues = {
    name: string
    campaignGoal: number
    toplinePercentage: number
    engagementBasis: 'mlr' | 'rfm'
}

export function numberInputToNumber(value: number | string | undefined | null): number {
    if (value === '' || value === undefined || value === null) {
        return NaN
    }
    return typeof value === 'number' ? value : Number(value)
}

export const organizationSettingsValidators = {
    name: (value: string) => (value?.trim() ? null : 'Enter a name'),
    campaignGoal: (value: number | string) => {
        const num = numberInputToNumber(value)
        if (Number.isNaN(num)) {
            return 'Enter a campaign goal'
        }
        if (num <= 0) {
            return 'Enter a campaign goal greater than zero'
        }
        return null
    },
    toplinePercentage: (value: number | string) => {
        const num = numberInputToNumber(value)
        if (Number.isNaN(num)) {
            return 'Enter a topline percentage'
        }
        if (num < 15 || num > 25) {
            return 'Enter a percentage between 15 and 25'
        }
        return null
    },
}

type OrganizationSettingsFormFieldsProps = {
    form: UseFormReturnType<OrganizationSettingsFormValues>
}

export function OrganizationSettingsFormFields({form}: OrganizationSettingsFormFieldsProps) {
    return (
        <Stack>
            <TextInput
                label="Organization Name"
                placeholder="Organization name"
                {...form.getInputProps('name')}
            />
            <NumberInput
                label="Campaign Goal (USD)"
                placeholder="e.g. 1000000"
                thousandSeparator=","
                prefix="$"
                min={0}
                clampBehavior="none"
                required
                {...form.getInputProps('campaignGoal')}
            />
            <NumberInput
                label="Topline Percentage"
                description="Lead gift as % of campaign goal (15–25%)"
                min={15}
                max={25}
                suffix="%"
                clampBehavior="none"
                required
                {...form.getInputProps('toplinePercentage')}
            />
            <Select
                label="Engagement Level Basis"
                description="Choose which field to use for calculating prospect engagement levels"
                data={[
                    {value: 'mlr', label: 'MLR Score'},
                    {value: 'rfm', label: 'RFM Total'},
                ]}
                {...form.getInputProps('engagementBasis')}
            />
        </Stack>
    )
}
